import React from 'react';
import { SectionCta } from '../SectionCta';
import { images } from '../../data/offer';
export function Creator() {
  return <section aria-labelledby="creator" className="bg-white px-4 py-16 sm:py-24" data-id="element-129" data-mp="1x2epyjh89wf0">
      <div className="mx-auto max-w-6xl" data-id="element-130" data-mp="1jb9p5e24iy33">
        <div className="grid items-center gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14" data-id="element-131" data-mp="1j840u11bk08f">
          <div className="relative" data-id="element-132" data-mp="1o9jjjmg0xunn">
            <img src={images.rachel} alt="Rachel Bennett, Critical Care Nursing Educator, in an ICU" className="aspect-square w-full rounded-3xl object-cover" data-id="element-133" data-mp="2bz5kaec1ohxr" />
            <div className="absolute bottom-4 left-4 right-4 rounded-2xl bg-navy-950/90 px-5 py-4 text-white backdrop-blur" data-id="element-134" data-mp="221hn7hqyuycf">
              <p className="font-display text-xl font-black" data-id="element-135" data-mp="26yhrpo863t1f">Rachel Bennett</p>
              <p className="text-sm text-aqua" data-id="element-136" data-mp="ql9qhwy7uh8o">Critical Care Nursing Educator</p>
            </div>
          </div>

          <div data-id="element-137" data-mp="vlfdv0xgdhky">
            <p className="font-display text-sm font-bold uppercase tracking-[0.14em] text-navy-700" data-id="element-138" data-mp="vlxiaku9r23y">About the creator</p>
            <h2 id="creator" className="mt-3 font-display text-[2rem] font-black leading-tight text-ink sm:text-5xl" data-id="element-139" data-mp="2xhycainkckmc">
              Hi, I’m Rachel Bennett
            </h2>
            <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/80" data-id="element-140" data-mp="37fvy6zhya5bs">
              <p data-id="element-141" data-mp="32egf3czc28w1">
                I created the ABG Clinical Roadmap™ around a simple educational idea:{' '}
                <strong className="text-ink" data-id="element-142" data-mp="3gdg1sf3acdpk">
                  complex information becomes easier to navigate when it is organized into a clear, consistent structure.
                </strong>
              </p>
              <p data-id="element-143" data-mp="3q40wvsjr303q">
                Arterial blood gas interpretation brings together several related concepts, including acid-base physiology,
                respiratory function, bicarbonate, compensation, and laboratory interpretation.
              </p>
              <p data-id="element-144" data-mp="3v4on4c05ncww">
                When these subjects are spread across different textbooks, notes, and reference materials, organizing a
                consistent study process can become unnecessarily complicated.
              </p>
              <p data-id="element-145" data-mp="b1bvhntay780">
                That’s why this collection brings the main educational topics together in six complementary volumes, supported
                by visual reference tables, practical worksheets, and simulated learning exercises.
              </p>
              <p data-id="element-146" data-mp="pqggtdve8rkc">
                My intention isn’t to replace your clinical training or suggest that a digital resource can solve every
                challenge in ABG interpretation. Instead, I want to provide an organized educational reference you can return to
                as you continue learning.
              </p>
              <p data-id="element-147" data-mp="13o4zqg5whomr">
                Whether you’re reviewing foundational concepts or practicing with simulated cases, the collection is designed to
                help you approach your study in a more structured way.
              </p>
              <p className="font-semibold text-ink" data-id="element-148" data-mp="35intcjcl4we0">I hope the ABG Clinical Roadmap™ becomes a useful part of your educational journey.</p>
              <p className="font-display text-xl font-black italic text-navy-700" data-id="element-149" data-mp="2t6bna940984j">— Rachel Bennett</p>
            </div>
          </div>
        </div>

        <SectionCta label="I want to study with Rachel’s roadmap" data-id="element-150" data-mp="2o5ea6axur49w" />
      </div>
    </section>;
}